/**
 * Created by pajicv on 10/7/18.
 */
import React from 'react';
import { TextField, withStyles, Typography } from '@material-ui/core';
import { updateTaskName } from '../../firebase/db';
import DownloadDocumentButton from './DownloadDocumentButton';
import TaskDescriptionField from './TaskDescriptionField';

const styles = theme => ({
    nameContent: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 40,
        width: 300
    },
    input: {
        textAlign: 'left'
    },
    title: {
        width: 470,
        padding: 30
    },
    workerCss: {
        display: 'flex',
        alignItems: 'flex-start',
        width: 700
    },
    managerColumn: {
        display: 'flex',
        flexDirection: 'column',
        height: 180
    }
});

class TaskTitle extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.task !== this.props.task) {
            this.setState({
                defaultName: this.props.task.name,
                description: this.props.task.description,
                name: this.props.task.name
            })
        }
    }

    handleChangeValue = (event) => {
        this.setState({ name: event.target.value });
    };

    handleBlur = () => {
        const { taskId } = this.props;
        const { name } = this.state;
        updateTaskName(taskId, name);
    };

    render() {
        const { classes, disabled, taskId, worker } = this.props;
        const { name, defaultName, description } = this.state;
        let taskDescription;
        if (defaultName === 'Personas') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FBEKB-Template-Persona.docx?alt=media&token=6b6f1c59-70fe-4ebb-baf4-bf4510471dbd'} />;
        } else if (defaultName === 'Ergebnisse') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FErgebnisse.docx?alt=media&token=833a2e2f-c7a3-4d27-b7ea-eb0bb932ccc3'} />;
        } else if (defaultName === 'IST Customer Journey') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FIST%20Customer%20Journey.docx?alt=media&token=70723bb8-dd63-481f-b3d4-373fa0be3190'} />;
        } else if (defaultName === 'Mitbewerberanalyse') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FMitbewerberanalyse.docx?alt=media&token=3be699aa-e127-4c98-9da1-d491edf63a4d'} />;
        } else if (defaultName === 'SOLL Customer Journey') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FSOLL%20Customer%20Journey.docx?alt=media&token=66b16870-9798-42f8-ad87-f63458f46dbb'} />;
        } else if (defaultName === 'Trends') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FTrends.docx?alt=media&token=6f13b516-ccef-4e91-a952-a1c2a98cd59e'} />;
        } else if (defaultName === 'Use Cases') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FUse%20Cases.docx?alt=media&token=d7d47ab2-8eb4-4137-a277-a6d26e5d808a'} />;
        } else if (defaultName === 'User Testing Prototyp') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FUser%20Testing%20Prototyp.docx?alt=media&token=3d9186bb-6770-46a5-af6f-1bb2e61d6b26'} />;
        } else if (defaultName === 'User Testing WF') {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} document={'https://firebasestorage.googleapis.com/v0/b/uxs-autumn.appspot.com/o/documents%2FUser%20Testing%20WF.docx?alt=media&token=f1c99f33-b07f-452d-b980-c80bbae43859'} />;
        } else {
            taskDescription = <DownloadDocumentButton worker={worker} description={description} className={classes.download} />;
        }
        return (
            <div className={worker && classes.workerCss || classes.nameContent}>
                <div className={classes.title}>
                    {!worker &&
                        <div>
                            <Typography variant="headline">Task</Typography>
                            <TextField
                                margin="normal"
                                value={name}
                                disabled={disabled}
                                className={classes.textField}
                                onChange={this.handleChangeValue}
                                onBlur={this.handleBlur}
                                inputProps={{
                                    className: classes.input
                                }}
                                placeholder="Define task title"
                            />
                        </div>
                    }
                </div>
                <div className={classes.managerColumn}>
                    {!worker &&
                        <TaskDescriptionField description={description} worker={worker} taskId={taskId} />
                    }
                    {taskDescription}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(TaskTitle);


// WEBPACK FOOTER //
// ./src/components/Tasks/TaskTitle.js